import { render } from "./safe-section.vue?vue&type=template&id=567904f0"
import script from "./safe-section.vue?vue&type=script&lang=js"
export * from "./safe-section.vue?vue&type=script&lang=js"

import "./safe-section.vue?vue&type=style&index=0&id=567904f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__